import React from 'react';
import RawText, { RawTextDefaultProps } from './RawText';
import PropTypes from 'prop-types';
import { st, classes } from './WsrText.st.css';
import Ellipsis, { extractEllipsisProps } from '../common/Ellipsis';
import { TooltipCommonPropTypes } from '../common/PropTypes/TooltipCommon';
const TextWithEllipsis = ({ ellipsis = false, appendTo = Ellipsis.defaultProps.appendTo, flip = Ellipsis.defaultProps.flip, fixed = Ellipsis.defaultProps.fixed, placement = Ellipsis.defaultProps.placement, zIndex = Ellipsis.defaultProps.zIndex, enterDelay = Ellipsis.defaultProps.enterDelay, exitDelay = Ellipsis.defaultProps.exitDelay, showTooltip = Ellipsis.defaultProps.showTooltip, size = RawTextDefaultProps.size, secondary = RawTextDefaultProps.secondary, skin = RawTextDefaultProps.skin, light = RawTextDefaultProps.light, weight = RawTextDefaultProps.weight, tagName = RawTextDefaultProps.tagName, listStyle = RawTextDefaultProps.listStyle, widows = RawTextDefaultProps.widows, id, ...propsWithNoDefaults }) => {
    const { className, tooltipProps, ...props } = {
        ...RawTextDefaultProps,
        ...Ellipsis.defaultProps,
        ellipsis,
        appendTo,
        flip,
        fixed,
        placement,
        zIndex,
        enterDelay,
        exitDelay,
        showTooltip,
        size,
        secondary,
        skin,
        light,
        weight,
        tagName,
        listStyle,
        id,
        widows,
        ...propsWithNoDefaults,
    };
    const { ellipsisProps, componentProps } = extractEllipsisProps(props);
    return (React.createElement(Ellipsis, { ...ellipsisProps, ...tooltipProps, wrapperClassName: st(classes.root, {
            // @ts-expect-error TODO: JB: stylable types
            size: props.size,
            // @ts-expect-error TODO: JB: stylable types
            weight: props.weight,
            listStyle: props.listStyle,
        }), render: ({ ref, ellipsisClasses, ellipsisInlineStyle }) => (React.createElement(RawText, { ...componentProps, ref: ref, className: ellipsisClasses(className), style: ellipsisInlineStyle })) }));
};
TextWithEllipsis.displayName = 'Text';
TextWithEllipsis.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    // @ts-expect-error TODO: JB: propTypes
    tagName: PropTypes.elementType,
    size: PropTypes.oneOf(['tiny', 'small', 'medium']),
    children: PropTypes.any,
    secondary: PropTypes.bool,
    skin: PropTypes.oneOf([
        'standard',
        'success',
        'error',
        'premium',
        'disabled',
        'primary',
    ]),
    listStyle: PropTypes.oneOf(['checkmark', 'circle']),
    light: PropTypes.bool,
    weight: PropTypes.oneOf(['thin', 'normal', 'bold']),
    id: PropTypes.string,
    tooltipProps: PropTypes.shape(TooltipCommonPropTypes),
    widows: PropTypes.bool,
    /*
     * Ellipsis props
     */
    /** Truncates text that is longer than its parent container and displays ellipsis at the end of the last line. */
    ellipsis: PropTypes.bool,
    /** Specifies whether to show a tooltip for ellipsis.  */
    showTooltip: PropTypes.bool,
    /*
     * Ellipsis => Tooltip props
     */
    zIndex: TooltipCommonPropTypes.zIndex,
    placement: TooltipCommonPropTypes.placement,
    disabled: TooltipCommonPropTypes.disabled,
    appendTo: TooltipCommonPropTypes.appendTo,
    flip: TooltipCommonPropTypes.flip,
    fixed: TooltipCommonPropTypes.fixed,
    enterDelay: TooltipCommonPropTypes.enterDelay,
    exitDelay: TooltipCommonPropTypes.exitDelay,
    maxWidth: TooltipCommonPropTypes.maxWidth,
    onShow: TooltipCommonPropTypes.onShow,
    onHide: TooltipCommonPropTypes.onHide,
    moveBy: TooltipCommonPropTypes.moveBy,
    moveArrowTo: TooltipCommonPropTypes.moveArrowTo,
    textAlign: TooltipCommonPropTypes.textAlign,
};
export default TextWithEllipsis;
//# sourceMappingURL=Text.js.map